export enum TestProcedure {
  Standard = 'S',
  AnnexA = 'A',
  AnnexB = 'B',
}
